import type { AddNewProfileModalFormProps } from './types'

export const initialFormValues: AddNewProfileModalFormProps = {
  profileDescription: '',
  profileType: '',
  status: '',
  observations: ''
}
